module.exports = __webpack_public_path__ + "img/fire_main_mo.7c6dec34.jpg";